
import { useEffect, useState } from 'react'

const useGetDefaultCourse = ({
  courseOptions,
  defaultUpfCourseId,
  selectedClass,
  selectedGroup,
  isCurriculumOrCourseChanged
}) => {
  const [defaultCourse, setDefaultCourse] = useState({});
  
  useEffect(() => {
    if ((selectedClass.value && selectedGroup.value) || isCurriculumOrCourseChanged) { 
      if (defaultUpfCourseId) {
        setDefaultCourse(courseOptions.find(course => course?.value === defaultUpfCourseId) || courseOptions[0])
      } else {
        setDefaultCourse(courseOptions[0])
      }
    } 
  }, [selectedClass.value, selectedGroup.value, defaultUpfCourseId, courseOptions.length, isCurriculumOrCourseChanged])

  return defaultCourse;
}

export default useGetDefaultCourse;


// WEBPACK FOOTER //
// ./components/course-filters/hooks/use-get-default-course.js